import React, { useContext } from "react";
import { Route, Routes } from "react-router-dom";

import Layout from "./components/Layout";

import { ROLES } from "./config/roles";
import Login from "./features/auth/Login";
import Signup from "./features/auth/Signup";
import ForgotPassword from "./features/auth/ForgotPassword";
import PasswordReset from "./features/auth/PasswordReset";
import Prefetch from "./features/auth/Prefetch";
import PersistLogin from "./features/auth/PersistLogin";
import RequireAuth from "./features/auth/RequireAuth";
import MainLayout from "./components/MainLayout/MainLayout";
import NotesList from "./features/notes/NotesList";
import NotesWithLabelList from "./features/labels/NotesWithLabelList";
import { ThemeContext } from "./app/context/theme";
import ManageAccount from "./features/user/ManageAccount";
import ManageProfile from "./features/user/ManageProfile";
import useTitle from "./hooks/useTitle";
function App() {
  useTitle("MarkNotes");

  const [{ theme, isDark }, toggleTheme] = useContext(ThemeContext); //allows us to get access to React context
  const style = {
    backgroundColor: theme.backgroundColor,
    color: theme.color,
    btnHoverColor: theme.btnHoverColor,
  };
  //we use styles and not classes to make it dynamic
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/*public*/}
        <Route path="login" element={<Login />} />
        <Route path="signup" element={<Signup />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="password-reset">
          <Route path=":token" element={<PasswordReset />} />
        </Route>
        {/*Protected Route*/}
        <Route element={<PersistLogin />}>
          <Route
            element={<RequireAuth allowedRoles={[...Object.values(ROLES)]} />}
          >
            <Route element={<Prefetch />}>
              <Route
                path="/"
                element={
                  <MainLayout
                    style={style}
                    theme={isDark}
                    onSwitchTheme={toggleTheme}
                  />
                }
              >
                <Route index element={<NotesList />} />
                {/*start from here has different route*/}
                <Route path="labels">
                  <Route path=":name" element={<NotesWithLabelList />} />
                </Route>
                <Route path="user">
                  <Route path="manage-profile" element={<ManageProfile />} />
                  <Route path="manage-account" element={<ManageAccount />} />
                </Route>
              </Route>
            </Route>
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}
export default App;
